import { useCallback, useContext, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import DateRange from '../../components/DateRange'
import Loader from '../../components/Loader'
import { Response } from '../../constants/types'
import { ProfileContext } from '../../Context'
import { getHotelAnalytics } from '../../helpers/api/hotels'
import Widget from '../widgets/Widget'

const Dashboard = () => {
  const { user, getProfileData } = useContext(ProfileContext)

  const [pageLoad, setPageLoad] = useState<boolean>(false)
  const [stats, setStats] = useState({
    availableRooms: '0/0',
    guestServed: 0,
    activeGuest: 0,
    paidRevenue: 0,
    pendingRevenue: 0,
    orderConfirmed: 0,
    orderPending: 0,
    orderRejected: 0,
    orderAccepted: 0,
    orderCompleted: 0,
    hoteliers: 0,
    revenuePercent: 0,
    completedRes: 0,
    pendingRes: 0,
    completedHouse: 0,
    pendingHouse: 0,
  })

  const setAppropriateStats = useCallback((data: any) => {
    console.log(stats)
    console.log(data)
    let totalGuest = 0
    data?.guests?.forEach((itm: any) => {
      const count: number = +itm?.guests
      if (itm?.isActive) {
        setStats((prev) => ({
          ...prev,
          activeGuest: count,
        }))
        totalGuest += count
      } else {
        totalGuest += count
      }
    })

    setStats((prev) => ({
      ...prev,
      guestServed: totalGuest,
    }))

    data?.orders?.forEach((itm: any) => {
      const order = +itm?.order
      switch (itm?.status) {
        case 'Completed':
          setStats((prev) => ({
            ...prev,
            orderCompleted: order,
          }))
          break
        case 'Confirmed':
          setStats((prev) => ({
            ...prev,
            orderConfirmed: order,
          }))
          break
        case 'Rejected':
          setStats((prev) => ({
            ...prev,
            orderRejected: order,
          }))
          break
        case 'Pending':
          setStats((prev) => ({
            ...prev,
            orderPending: order,
          }))
          break
        case 'Accepted':
          setStats((prev) => ({
            ...prev,
            orderAccepted: order,
          }))
          break
      }
    })

    let totalRooms = 0
    let availableRooms = 0
    data?.room?.forEach((itm: any) => {
      const count: number = +itm?.count
      if (itm?.isAvailable) {
        availableRooms = count
        totalRooms += count
      } else {
        totalRooms += count
      }
    })
    setStats((prev) => ({
      ...prev,
      availableRooms: `${availableRooms}/${totalRooms}`,
    }))

    let pendingRevenue = 0
    let paidRevenue = 0
    let completedRes = 0
    let pendingRes = 0
    let completedHouse = 0
    let pendingHouse = 0

    // data?.revenueForHotelierDashboard.forEach((itm: any) => {
    //   const amount = +itm?.amount
    //   switch (itm?.status) {
    //     case 'Pending':
    //       pendingRevenue = amount
    //       break
    //     case 'Paid':
    //       paidRevenue = amount
    //       break
    //   }
    // })
    // const totalRevenue = paidRevenue + pendingRevenue
    // const revenuePercent =
    //   totalRevenue === 0 ? 0 : Math.round((paidRevenue / totalRevenue) * 100)

    data?.restaurantOrders?.forEach((itm: any) => {
      const order = +itm?.order
      switch (itm?.status) {
        case 'Completed':
          completedRes = order
          break
        case 'Pending':
          pendingRes = order
          break
      }
    })

    data?.houseKeepingOrders?.forEach((itm: any) => {
      const order = +itm?.order
      switch (itm?.status) {
        case 'Completed':
          completedHouse = order
          break
        case 'Pending':
          pendingHouse = order
          break
      }
    })

    setStats((prev) => ({
      ...prev,
      hoteliers: data?.hoteliers?.count || 0,
      pendingRevenue,
      paidRevenue,
      // revenuePercent,
      completedRes,
      pendingRes,
      completedHouse,
      pendingHouse,
    }))
  }, [])

  const getDetails = useCallback(
    async (params?: any) => {
      setPageLoad(true)
      if (user.id) {
        let res: Response = (await getHotelAnalytics(
          user.id,
          params,
        )) as Response
        setAppropriateStats(res?.data?.data)
      }
      setPageLoad(false)
    },
    [setAppropriateStats, user.id],
  )

  useEffect(() => {
    getDetails()
    getProfileData()
  }, [getDetails, getProfileData])

  return (
    <>
      {pageLoad && <Loader />}
      <DateRange onApply={getDetails} />
      <Row>
        <Col>
          <div className="page-title-box">
            <h4 className="page-title">Dashboard</h4>
          </div>
        </Col>
      </Row>

      <Row className="g-2">
        <Col>
          <Widget stats={stats.availableRooms} title="Available Rooms" />
        </Col>
        <Col>
          <Widget stats={stats.guestServed} title="Guest Served" />
        </Col>
        <Col>
          <Widget stats={stats.activeGuest} title="Active Guest" />
        </Col>
        <Col>
          <Widget stats={stats.hoteliers} title="Staff" />
        </Col>

        <Col>
          <Card className="h-100" style={{ minWidth: '200px' }}>
            <Card.Body>
              <Card.Title>Restaurant Orders</Card.Title>
              <div className="d-flex justify-content-between">
                <div>
                  <p className=" fw-bold fs-4 mb-1">
                    {`Completed - ${stats.completedRes}`}
                  </p>
                  <p className="fs-5">{`Pending - ${stats.pendingRes}`}</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100" style={{ minWidth: '200px' }}>
            <Card.Body>
              <Card.Title>Housekeeping Orders</Card.Title>
              <div className="d-flex justify-content-between">
                <div>
                  <p className=" fw-bold fs-4 mb-1">
                    {`Completed - ${stats.completedHouse}`}
                  </p>
                  <p className="fs-5">{`Pending - ${stats.pendingHouse}`}</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default Dashboard
